/**
 * ? @description : SPOC : Mapped Profiles Tab
 */

// Dependencies
import React, { useState, useEffect } from "react";
import MUIDataTable, { TableFilterList } from "mui-datatables";
import { useDispatch } from "react-redux";


// MUI Icons
import MoreVertIcon from "@mui/icons-material/MoreVert";

// Components
// import MappedModalDelete from "./modals/MappedModalDelete";

// Axios Component
import Axios from "../../../../../axios/Axios";

// Redux Component
import { showSnackbar } from "../../../../redux/features/appSlice";
import { Chip, CircularProgress, IconButton,  Typography } from "@mui/material";
import { LibraryBooks } from "@mui/icons-material";
import TeacherModal from "./Modals/TeacherModal";
import StudentModal from "./Modals/StudentModal";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import CommentsModal from "../../../../Reusable/CommentsModalReuse";
import { ShowFullText } from "../../../../Reusable/ShowMoreText";
import axios from "axios";
import { useSelector } from "react-redux";

function MappedProfiles() {
  // * Redux
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {access_token} = useSelector(state => state.user.user);
  const spoc_id = sessionStorage.getItem("user_id");
  // * State Variables
  // const [data, setData] = useState([]);
  const [mappedData, setMappedData] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [teacherId,setTeacherId] = useState()
  const [teacherModal, setTeacherModal] = useState(false);
  const [studentModal, setStudentModal] = useState(false);
  // const [sessionModal, setSessionModal] = useState(false);
  const [commentModal, setCommentModal] = useState(false);
  const [isDataFetchError, setIsDataFetchError] = useState(false);
  // const [deleteModal, setDeleteModal] = useState(false);

//   const StyledTooltip = ({ className, ...props }) => (
//     <Tooltip {...props} classes={{ tooltip: className }} />
// );
//   const ShowFullText = styled(StyledTooltip)(({theme}) => ({
//     backgroundColor: 'white',
//     color: 'black',
//     maxWidth: 500,
//     fontSize: "15px",
//     boxShadow: theme.shadows[5]
// }));
     // for comment section 
     const [reloadComments, setReloadComments] = useState(false);
     const handleCommentsModalClose = () => {
       setReloadComments(!reloadComments);
     };

       // for pagination state 
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
  };
  // * Columns Declaration for Table
  const columns = [
    {
      name: "map_id",
      label: "Mapped Id",
      options: {
        display:false,
        filter: false,
        filterType: "dropdown",
        sort: true,
        sortDirection: "desc",
      },
    },
    {
      name: "teacher_id",
      label: "Teacher Id",
      options: {
        display:false,
        filter: false,
        filterType: "dropdown",
      },
    },
    {
      name: "teacher_name",
      label: "Teacher Name",
      options: {
        filter: false,
        filterType: "dropdown",
        customBodyRender: (value) => {
           console.log(value);
          return(
            <Chip 
              label={value} 
              color="primary" 
              clickable
              onClick={() => setTeacherModal(true)}
            />
          )
        }
      },
    },
    {
      name: "student_id",
      label: "Student Id",
      options: {
        display:false,
        filter: false,
        filterType: "dropdown",
      },
    },
    {
      name: "student_name",
      label: "Student Name",
      options: {
        filter: false,
        filterType: "dropdown",
        customBodyRender: (value) => {
          return(
            <Chip 
              label={value} 
              color="primary" 
              clickable
              onClick={() => {
                setTeacherId()

              }}
            />
          )
        }
      },
    },
    // {
    //   name: "batch_id",
    //   label: "Batch Id",
    //   options: {
    //     filter: false,
    //     filterType: "dropdown",
    //   },
    // },
    // {
    //   name: "batch_name",
    //   label: "Batch Name",
    //   options: {
    //     filter: true,
    //     filterType: "dropdown",
    //   },
    // },
    {
      name: "comment_desc",
      label: "Comments",
      options: {
        filter: false,
        filterType: "dropdown",
        customBodyRender :(value) =>{
          // console.log(value);
          return (
            <ShowFullText title={value}>
             <Typography variant='p' sx={{ cursor:'pointer'}}>
              {value && value.length> 25? `${value.substring(0,25)}...` : value}
             </Typography>
            </ShowFullText>
          )
        }
      },
    },
    {
      name: "Level Details",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (_, data) => {
          // console.log(data);
          let studentId = data.rowData[3]
          return (
            <IconButton onClick={() => navigate("/spoc/student-level-details", { state: studentId})}>
              <LibraryBooks color="primary"></LibraryBooks>
            </IconButton>
          );
        },
      },
    },
    {
      name: "ACTIONS",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: () => {
          return (
            <div>
              <Dropdown>
                <Dropdown.Toggle
                  variant="primary rounded-circle"
                  id="dropdown-basic"
                >
                  <MoreVertIcon />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item href="#" onClick={() => setCommentModal(true)}>
                    Create / View comment
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          );
        },
      },
    },
  ];

  // * Function Call
  useEffect(() => {
    // ? Get Method : Get Mapped Data from Server
    const controller = axios.CancelToken.source();

    (async () => {
      try {

        let options = {
          method: "get",
          url: `mapping/get/spoc/mappingdetails/${spoc_id}`,
          auth: true,
          data: null,
          token:`${access_token}`,

        };

        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data,
          options.token,
        );
        
        // console.log(response);
        if(response.status === 200){
          // let mapData = response.data.flatMap(data => data);
          response.data.length !== 0 ? setMappedData(response.data) : setIsDataFetchError(true);
          // console.log(response);
        }
      } catch (error) {
        if (!axios.isCancel(error)){
          console.log(error);
          setIsDataFetchError(true);
          dispatch(
            showSnackbar({
              message: "Unable to get mapped data.",
              severity: "error",
            })
          );
        }
      }
    })()
    return () => {
      controller.cancel();
  }
  }, [dispatch, spoc_id,rowsPerPage, reloadComments ]);

  // * Options Configuration for Table
  const options = {
    textLabels: {
      body: {
        noMatch: isDataFetchError ? "Sorry, No Data available" : <CircularProgress />,
      }
    },
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    elevation: 0,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [5, 10, 20],
    onChangeRowsPerPage: handleRowsPerPageChange ,
    fixedHeader: true,
    fixedSelectColumn: true,
    tableBodyHeight: "auto",
    jumpToPage: true,
    onRowClick: (data) => {
      // console.log(rowData);

      setRowData(data);
    },
   
    
    customSearch: (searchQuery, currentRow, columns) => {
      currentRow.forEach(col => {
        if (col && col.toString().indexOf(searchQuery) >= 0) {
          return setIsDataFetchError(true);
        }
      });
    }
  };

  const CustomChip = ({ label, onDelete }) => {
    return (
      <Chip
        variant="outlined"
        color="secondary"
        label={label}
        onDelete={onDelete}
      />
    );
  };

  const CustomFilterList = (props) => {
    return <TableFilterList {...props} ItemComponent={CustomChip} />;
  };

  // console.log(mappedData);
  return (
    <div 
    // style={{ height: "70vh", overflow: "auto" }}
    >
      
      {/* Table */}
      <MUIDataTable
        title={`Mapped Data (${mappedData.length})`}
        data={mappedData}
        columns={columns}
        options={options}
        components={{
          TableFilterList: CustomFilterList,
        }}
      />

      {/* Modal */}
      {/* <MappedModalDelete
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        tabledata={data}
      /> */}

      <TeacherModal
        show={teacherModal}
        onHide={() => setTeacherModal(false)}
        tabledata={rowData}
      />

      <StudentModal
        show={studentModal}
        onHide={() => setStudentModal(false)}
        tabledata={rowData}
      />

      {/* <SessionDetails
        show={sessionModal}
        onHide={() => setSessionModal(false)}
        tabledata={rowData}
      /> */}
       {/*Comments modal*/}
       <CommentsModal
        show={commentModal}
        onHide={() => setCommentModal(false)}
        // commentstomodal={tableData}
        tabledata={rowData}
        modalname="mappingcomments"
        postcomment={"comments/map"}
        getcomment={"comments/map/mapping/"}
        onCloseCallback ={handleCommentsModalClose}
      />
    </div>
  );
}

export default MappedProfiles;
